import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Button, Icon, H2, Modal, NewButton, Text } from '../../../../../components';

const DeleteSpaceModalHeader = styled.div`
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}`;

const DeleteSpaceModalFooter = styled.div`
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 12px;
`;

const DeleteSpaceModalBody = styled.div`
  padding: 12px 24px 24px;
`;

const DeleteSpaceModal = ({ title, onDeleteSpace }) => (
  <Modal size='sm'>
    {(close) => (
      <>
        <DeleteSpaceModalHeader>
          <H2>Leave space</H2>
          <NewButton tertiary onClick={close}>
            <Icon name='close' size={24} />
          </NewButton>
        </DeleteSpaceModalHeader>
        <DeleteSpaceModalBody>
          <Text>
            Deleting <strong>{title}</strong> will remove all content from this view permanently.
            <br />
            This action cannot be undone.
          </Text>
        </DeleteSpaceModalBody>
        <DeleteSpaceModalFooter>
          <Button onClick={close} tertiary>
            Cancel
          </Button>
          <Button
            onClick={() => {
              onDeleteSpace();
              close();
            }}
            secondary
          >
            Delete permanently
          </Button>
        </DeleteSpaceModalFooter>
      </>
    )}
  </Modal>
);

DeleteSpaceModal.propTypes = {
  title: PropTypes.string.isRequired,
  onDeleteSpace: PropTypes.func.isRequired
};

export { DeleteSpaceModal };
